import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
// Components
import { CopyToClipboard } from '@/common/index';
// Styles
import styles from './qr-copy.module.css';
import { Box, Divider, Typography } from '@mui/material';

export default function QRCopy({
  copyAddress,
  qrSize,
  isVertical = false,
  coin = 'Ethereum',
}) {
  const qrRef = useRef();
  useEffect(() => {
    if (qrRef?.current) {
      const qrCodeOptions = {
        margin: 0,
        width: qrSize,
      };
      QRCode.toCanvas(qrRef.current, copyAddress, qrCodeOptions, function (error) {
        if (error) console.error({ error });
      });
    }
  }, [qrRef, copyAddress, qrSize]);

  return (
    <div className={styles.contentContainer}>
      <div className={isVertical ? styles.qrVertical : styles.qrWrapper}>
        <div>
          <Box sx={{ marginBottom: '16px' }}>
            <Typography variant="h5">Scan QR Code</Typography>
          </Box>
          <div className={styles.row}>
            <Typography variant="body1">
              Within your {coin} compatible wallet, select to use your phone’s camera to
              scan the QR code. This will automatically copy the address to send funds to
              your wallet.
            </Typography>
            <div className={styles.qrImage}>
              <canvas ref={qrRef} data-core-qa="walletQRCode"></canvas>
            </div>
          </div>
        </div>
        <div className={isVertical ? styles.qrOrMobile : styles.qrOr}>
          <Divider textAlign="center" sx={{ marginTop: '16px', marginBottom: '16px' }}>
            OR
          </Divider>
        </div>
        <div>
          <Box sx={{ marginBottom: '16px' }}>
            <Typography variant="h5">Copy Wallet Address</Typography>
          </Box>
          <div className={styles.row}>
            <Typography variant="body1">
              Copy the wallet address {isVertical ? 'below' : null} into the send field of
              your {coin} compatible wallet.
            </Typography>
            <div className={styles.copyAddress}>
              <CopyToClipboard copyText={copyAddress} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
